import { render, staticRenderFns } from "./providerTab.vue?vue&type=template&id=006e1fb9&lang=pug"
import script from "./providerTab.vue?vue&type=script&lang=js"
export * from "./providerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports